import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import {
  IconAdd,
  IconCaretDown,
  IconCaretUp
} from '@contrast-security-inc/design-system-foundations'

interface IntegrationListItemProps {
  readonly icon: string
  readonly iconClass?: string
  readonly isOpen?: boolean
  readonly isConnected: boolean
  readonly getUrlRoute: () => string
  readonly title: string
  readonly connectToLabelId: string
  readonly children?: React.ReactNode
}

export const IntegrationListItem = ({
  icon,
  iconClass = '',
  isOpen = false,
  isConnected = false,
  getUrlRoute,
  title,
  connectToLabelId,
  children
}: IntegrationListItemProps) => {
  const [isOpenState, setIsOpenState] = useState(isOpen)
  const { formatMessage } = useIntl()

  const toggleIsOpen = () => {
    setIsOpenState(!isOpenState)
  }

  const connectRoute = getUrlRoute()

  return (
    <>
      <div
        className={`flex-container integration ${isOpen && 'no-border-bottom'}`}
      >
        <div className={`integration-icon no-shrink align-center ${iconClass}`}>
          <span>
            <img src={icon} alt={title} />
          </span>
        </div>
        <div className="grow align-center">
          <div className="integration-title">{title}</div>
          {!isConnected && (
            <div className="integration-connect-text">
              <FormattedMessage id={connectToLabelId} />
            </div>
          )}
          {children ? (
            children
          ) : (
            <>
              {isConnected && (
                <div>
                  <span>
                    <a
                      className="no-underline text-smaller"
                      onClick={() => toggleIsOpen()}
                    >
                      {!isOpenState && (
                        <>
                          <span>
                            <FormattedMessage
                              id={'action_integrationsSettings_showConfig'}
                            />
                          </span>
                          <IconCaretDown color="neutral50" size="md" />
                        </>
                      )}
                      {isOpenState && (
                        <>
                          <span>
                            <FormattedMessage
                              id={'action_integrationsSettings_hideConfig'}
                            />
                          </span>
                          <IconCaretUp color="neutral50" />
                        </>
                      )}
                    </a>
                  </span>
                  <span className="integration-show text-smaller">
                    <a href={connectRoute}>
                      <span>
                        <IconAdd />
                        <FormattedMessage
                          id={'action_integrationsSettings_addConfig'}
                        />
                      </span>
                    </a>
                  </span>
                </div>
              )}
            </>
          )}
        </div>
        <div className="no-shrink align-center btn-group integration-connect">
          <div className="inline-formatMessageblock-full">
            {!isConnected ? (
              <a href={connectRoute} className="btn btn-info">
                <span>
                  {formatMessage({ id: 'action_integrationsSettings_connect' })}
                </span>
              </a>
            ) : (
              <button className="btn btn-default" disabled>
                <span>
                  {formatMessage({
                    id: 'title_integrationsSettings_statusConnected'
                  })}
                </span>
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
